import { DocumentType } from '~/graphql/graphql';
import type { OrderDocument, UploadType } from '~/graphql/graphql';

export type OrderDocumentType = Omit<OrderDocument, 's3Key' | 'organization'>;

const UPLOAD_TYPE_LABELS: Record<UploadType, string> = {
  BUYER_UPLOAD: 'Buyer upload',
  SELLER_UPLOAD: 'Seller upload',
};

export const DOCUMENT_TYPES = Object.values(DocumentType);

export function formatUploadType(uploadType: UploadType): string {
  return UPLOAD_TYPE_LABELS[uploadType];
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
